package pl.michal_cyran.brand_hub.subpages.tutoring.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.icons.fa.FaAtom
import com.varabyte.kobweb.silk.components.icons.fa.FaCalculator
import com.varabyte.kobweb.silk.components.icons.fa.FaCompactDisc
import com.varabyte.kobweb.silk.components.icons.fa.FaComputer
import com.varabyte.kobweb.silk.components.icons.fa.FaGraduationCap
import com.varabyte.kobweb.silk.components.icons.fa.FaLaptopCode
import com.varabyte.kobweb.silk.components.icons.fa.FaRobot
import com.varabyte.kobweb.silk.components.icons.fa.FaSchool
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H2 // Zmiana z H1 na H2
import org.jetbrains.compose.web.dom.P  // Zmiana z H3 na P dla poprawnej hierarchii HTML
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.subpages.tutoring.composables.OfferCard
import pl.michal_cyran.brand_hub.subpages.tutoring.composables.OfferHeading

@Composable
fun TutoringOffer(
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        // ZMIANA SEO: H1 zmienione na H2, a treść wzbogacona o słowa kluczowe
        H2 {
            Text("Oferta korepetycji – matematyka i informatyka")
        }

        // ZMIANA SEO: Zamiana H3 na P w celu poprawnego semantycznego ustrukturyzowania kodu
        P {
            Text("Indywidualne zajęcia w Krakowie (Ruczaj) oraz online, w pełni dopasowane do Twojego poziomu.")
        }

        SimpleGrid(
            numColumns = numColumns(base = 1, md = 2),
            modifier = Modifier.fillMaxWidth().gap(1.cssRem)
                .id("offer"),
        ) {
            Column(
                modifier = Modifier,
                verticalArrangement = Arrangement.spacedBy(1.cssRem)
            ) {
                OfferHeading(
                    title = "Korepetycje z matematyki",
                    icon = { size -> FaCalculator(size = size) },
                    modifier = Modifier.padding(bottom = 16.px)
                )

                OfferCard(
                    icon = { size -> FaGraduationCap(size = size) },
                    title = "Szkoła podstawowa",
                    // ZMIANA SEO: Dodanie frazy "egzamin ósmoklasisty z matematyki"
                    description = "Skuteczna pomoc w nadrabianiu zaległości, bieżącym materiale oraz profesjonalne przygotowanie do egzaminu ósmoklasisty z matematyki.",
                    index = 0,
                )

                OfferCard(
                    icon = { size -> FaSchool(size = size) },
                    title = "Szkoła średnia – matura podstawowa",
                    // ZMIANA SEO: Dodanie "matura z matematyki", "wymagania CKE"
                    description = "Bieżące wsparcie w nauce szkolnej oraz kompleksowe powtórki do matury z matematyki na poziomie podstawowym zgodnie z aktualnymi wymaganiami CKE.",
                    index = 1,
                )

                OfferCard(
                    icon = { size -> FaAtom(size = size) },
                    title = "Szkoła średnia – matura rozszerzona",
                    // ZMIANA SEO: Precyzyjne określenie grupy docelowej i celów
                    description = "Zaawansowane korepetycje dla uczniów klas matematyczno-fizycznych oraz solidne przygotowanie do matury rozszerzonej na wysoki wynik.",
                    index = 2,
                )
            }

            Column(
                modifier = Modifier,
                verticalArrangement = Arrangement.spacedBy(1.cssRem)
            ) {
                OfferHeading(
                    title = "Korepetycje z informatyki",
                    icon = { size -> FaComputer(size = size) },
                    modifier = Modifier.padding(bottom = 16.px)
                )

                OfferCard(
                    icon = { size -> FaRobot(size = size) },
                    title = "Szkoła podstawowa",
                    // ZMIANA SEO: Doprecyzowanie technologii
                    description = "Wprowadzenie do świata algorytmów, nauka logicznego myślenia oraz pomoc w szkolnych projektach (Scratch, podstawy Pythona).",
                    index = 0,
                )

                OfferCard(
                    icon = { size -> FaLaptopCode(size = size) },
                    title = "Szkoła średnia & Technikum",
                    // ZMIANA SEO: Dodanie konkretnych kierunków i języków programowania
                    description = "Wsparcie dla uczniów technikum informatycznego i programistycznego. Nauka programowania w językach C++, Python oraz bazy danych SQL.",
                    index = 1,
                )

                OfferCard(
                    icon = { size -> FaCompactDisc(size = size) },
                    title = "Egzaminy zawodowe INF.03, INF.04",
                    // ZMIANA SEO: Wpisanie konkretnych nazw kwalifikacji, które uczniowie wyszukują w Google
                    description = "Teoretyczne i praktyczne przygotowanie do państwowych egzaminów zawodowych z kwalifikacji INF.03, INF.04 (dawniej EE.09, E.14).",
                    index = 2,
                )
            }
        }

        Box(modifier = Modifier.height(24.px))
    }
}